/**
 * Icon Component - Template
 * =========================
 */

export const ICON_TEMPLATE: string = `
<span
  class="ec-icon ec-inline-block ec-align-middle"
  ng-class="$ctrl.sizeClasses"
  ng-bind-html="$ctrl.trustedSvg"
  ng-attr-role="{{ $ctrl.ariaLabel ? 'img' : undefined }}"
  ng-attr-aria-label="{{ $ctrl.ariaLabel || undefined }}"
  ng-attr-aria-hidden="{{ $ctrl.ariaLabel ? undefined : 'true' }}"
></span>
`;

export default ICON_TEMPLATE;
